import React, { useContext, useState } from 'react'
import { CButton } from 'app/components/Common'
import { IconDeviceDesktop, IconDeviceMobile } from '@tabler/icons-react'
import { ThemeContext } from 'theme/ThemeProvider'
import styled from 'styled-components'
import { useThemeStore } from 'app/hooks'

const MobileToggle = () => {
	const { isMobile, toggleMobile, theme } = useContext(ThemeContext)
	const [rotated, setRotated] = useState<boolean>(false)

	const { data: themeStore, mutate: mutateThemeStore } = useThemeStore()
	if (themeStore?.isMobile === undefined) {
		mutateThemeStore({
			isMobile: false,
		})
	}

	const icon = isMobile ? (
		<IconDeviceMobile color={theme.COLORS.textw} size={16} />
	) : (
		<IconDeviceDesktop
			color={theme.COLORS.textw}
			style={{ color: theme.COLORS.textw }}
			size={16}
		/>
	)
	return (
		<Wrapper
			rotated={rotated}
			onClick={() => {
				toggleMobile()
				setRotated(true)
				mutateThemeStore({
					...themeStore,
					isMobile: isMobile ? false : true,
				})
			}}>
			<CButton icon={icon} />
		</Wrapper>
	)
}

const Wrapper = styled.div<{ rotated?: boolean }>`
	transition: transform 0.2s ease-in-out;
	margin-left: 10px;
	margin-right: 10px;
	display: flex;
	cursor: pointer;
	align-items: center;
	&:active {
		transform: scale(0.95);
	}
	&:focus {
		outline: none;
		transform: scale(1.05);
	}
`
export default MobileToggle
